import React from 'react';
import { AirtableDataConsumer, AirtableContextData } from '../../core/AirtableDataProvider';
import { nestPages } from './pageUtil';
import { Link } from 'gatsby';

interface Props { }

export default class PageNavMobile extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const pages = nestPages(data.airtable.pages);

    return (
      <div className="flex flex-column bg-near-white">
      { pages.map(page =>
        <div key={ page.meta.Slug } className="flex flex-column">

          <Link
            className="pv3 ph4 bb b--light-gray link dark-gray dim pt3"
            activeClassName="b"
            to={ `/${ page.meta.Path || page.meta.Slug }` }>
            { page.meta.Caption }
          </Link>

          { page.children.map(c =>
            <Link
              key={ c.meta.Slug }
              className="pv3 pr4 pl5 bb b--light-gray link dark-gray dim pt3" to={ `/${ c.meta.Path || c.meta.Slug }` }
              activeClassName="b">
              { c.meta.Caption }
            </Link>
          ) }


        </div>
      ) }
      </div>
    );
  }

}